module.exports = __webpack_public_path__ + "static/media/timer.499eb794.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/timer.svg
// module id = 188
// module chunks = 0